import { createI18nText } from '@hilma/netina2all';

const purchaseText = createI18nText({
	he: {
		title: 'רכישה',
		personalDetails: 'פרטים אישיים',
		selectKit: 'בחירת מוצרים',
		selectItems: 'בחירת מוצרים',
		selectStation: 'בחירת תחנה',
		selectAssociation: 'בחירת עמותה',
		atonementLabel: 'מתנות לאביונים',
		atonementTitle: 'תרומת מתנות לאביונים (מוכר ע"פ סעיף 46)',
		orderSummary: 'פרטי הזמנה',
		orderSummaryLabel: 'סיכום הזמנה',

		payment: 'תשלום',

		next: 'הבא',
		back: 'חזור',
		submit: 'תשלום',
		confirmLeave: 'האם אתה בטוח שברצונך לצאת מהליך הרישום?\nהמידע שהזנת עד כה יאבד'

	},
	en: {
		title: 'Purchasing',
		personalDetails: 'Personal Details',
		selectKit: 'Product Selection',
		selectItems: 'Item Selection',
		selectStation: 'Station Selection',
		selectAssociation: 'Association Selection',
		atonementLabel: "Matanot L'evyonim",
		atonementTitle: "Matanot L'evyonim (Recognized According to Section 46)",
		orderSummary: 'Order Details',
		orderSummaryLabel: 'Order Summary',

		payment: 'Payment',

		next: 'Next',
		back: 'Back',
		submit: 'Payment',
		confirmLeave: 'Are you sure you want to leave the registration process?\nThe information you entered will be lost'
	}
});

export default purchaseText;